export const optionTitle_readingPane = "yqHYDd";
export const optionTitle_readingPaneLayout = "mHRpXb";
export const optionSearch_readingPane = "O$EVRd";
export const options_readingPane_right = "s9G0_";
export const options_readingPane_bottom = "nFzlje";
export const options_readingPane_classic = "_lXZoe";
export const options_readingPane_popout = "NJsoQb";
export const options_readingPane_resize = "yS4H6b";
export default {optionTitle_readingPane,optionTitle_readingPaneLayout,optionSearch_readingPane,options_readingPane_right,options_readingPane_bottom,options_readingPane_classic,options_readingPane_popout,options_readingPane_resize};